import type { AppSettingsDoc, SystemSettingsDoc } from '../firestore/schemas';

// Stand in for a missing or invalid settings value, and are the values write-billing-settings.ts writes.
export const DEFAULT_SYSTEM_SETTINGS: Omit<SystemSettingsDoc, 'updatedAt'> = {
  aiPreviewCredits: 1000,
  trialDays: 30,
  trialCredits: 1000,
  gracePeriodQuotaPercent: 10,
};

export const DEFAULT_APP_SETTINGS: Omit<AppSettingsDoc, 'updatedAt'> = {
  quotaPercentUsedWarning: 90,
  creditsPerTypicalNote: 20,
};
